module.exports = __webpack_public_path__ + "static/media/smart_health.bf6725a8.png";